import { useMutation } from '@tanstack/react-query';

import ProductImagesService, {
  UploadedImageFile,
} from '@/services/ProductImagesService';

interface UploadArgs {
  files: File[];
  onProgress?: (percent: number) => void;
  concurrency?: number;
}

export function useUploadProductImages() {
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: ({ files, onProgress, concurrency }: UploadArgs) =>
      ProductImagesService.upload(files, { onProgress, concurrency }),
  });

  return {
    uploadImages: mutateAsync as (
      args: UploadArgs,
    ) => Promise<UploadedImageFile[]>,
    isLoading: isPending,
    error,
  };
}
